import * as React from 'react';
import { useSelector } from 'react-redux';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer, useLocalizerFormat } from './hooks/useLocalizer';
import { ApplicationState } from '../../../store';
import {
    AiSurveyOperationMetadata,
    DataCollectionAiAgentOperationType
} from '../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseModels';
import { getActiveAIOperationFromState } from '../../../store/StateControllers/Survey/SurveyResponse/AISurveyAgentController';

interface AIProcessingSummaryProps {
    agentState?: string | null;
    localizer?: IStringLocalizer;
    operationType?: DataCollectionAiAgentOperationType | null;
}

export const AIProcessingSummary: React.FC<AIProcessingSummaryProps> = ({
    agentState,
    localizer,
    operationType
}) => {
    const localize = useLocalizer(localizer);
    const localizeFormat = useLocalizerFormat(localizer);
    
    const aiOperation = useSelector((state: ApplicationState) =>
        getActiveAIOperationFromState(state.aiSurveyAgentState, operationType)
    );
    const metadata: AiSurveyOperationMetadata | null = aiOperation?.metadata ?? null;

    // Calculate summary stats
    const materialsProcessed = metadata?.materialsProcessed ?? 0;
    const materialsRequested = metadata?.materialsRequested ?? 0;
    const questionsAnswered = metadata?.aiAnswersProvided ?? 0;
    const questionsAsked = metadata?.questionsAsked ?? 0;

    return (
        <div className="ai-processing-summary">
            <p className="ai-questions-summary">
                {localizeFormat("{0} of {1}", materialsProcessed, materialsRequested)} {localize("materials processed")} · {localizeFormat("{0} of {1}", questionsAnswered, questionsAsked)} {localize("questions answered")}
            </p>
        </div>
    );
};

export default AIProcessingSummary;
